$(function () {
    'use strict';

    //////////////////////////////////////////////////////////////////////////////////////
    //
    // V A R I A B L E S
    //
    //////////////////////////////////////////////////////////////////////////////////////

    var $fn = {},
        $el = {
            window       : $(window),
            html         : $('html'),
            body         : $('body'),
            document     : $(document)
        },
        param = {
            winW: window.innerWidth || $el.window.width(),
            winH: window.innerHeight || $el.window.height(),
            docW: $el.document.outerWidth(),
            docH: $el.document.outerHeight(),
            switch_flg: '',
            flkty: ''
        };

    // $fn.change_image = function () {
    //     var img = '';
    //     if(param.winW <= 768){
    //         $('.js-c-image').each(function () {
    //             img = $(this).attr('src');
    //             if(img.indexOf('sp') === -1) {
    //                 img = img.replace('.svg', '_sp.svg');
    //                 console.log(img);
    //                 $(this).attr('src', img);
    //             }
    //         });
    //     }else{
    //         $('.js-c-image').each(function () {
    //             if(img.indexOf('sp') === -1) {
    //
    //                 img = $(this).attr('src').replace("_sp.svg", ".svg");
    //                 $(this).attr('src', img);
    //             }
    //         });
    //     }
    // };
    // $fn.change_image();

    $fn.mainimgSize = function () {
        var $target = $('.main-carousel');
        var $target_parent = $('.l-index-carousel--inner');
        var ratio = .64;

        var mainImgW = $('.carousel-cell img').width();
        var mainW = $target_parent.width();

        if ($target_parent.length) {

            if ($target_parent.height() / $target_parent.width() < ratio) {
                $(".main-carousel li.carousel-cell").each(function(index, el) {
                    param.leftPos = '';
                    $('img',this).addClass('vertical');
                    $('img',this).removeClass('horizontal');
                });


            } else {
                mainImgW = mainImgW/2;
                mainW = mainW/2;
                param.leftPos = mainW-mainImgW;
                $(".main-carouse li.carousel-cell").each(function(index, el) {
                    $('img',this).addClass('horizontal');
                    $('img',this).removeClass('vertical');
                });
            }
        }

    };


    $('.toggle').on('click',function () {
        if( $('body').hasClass('open')){
            $('body').removeClass('open');
        }else{
            $('body').addClass('open');
        }
    });






    $(window).resize(function() {
        param = {
            winW: window.innerWidth || $el.window.width(),
            winH: window.innerHeight || $el.window.height(),
            docW: $el.document.outerWidth(),
            docH: $el.document.outerHeight(),
            switch_flg: '',
            flkty: ''
        };
        $fn.change_image();
    });

});

$(window).on('load',function() {
    var $fn = {},
        $el = {
            window       : $(window),
            html         : $('html'),
            body         : $('body'),
            document     : $(document)
        },
        param = {
            winW        : window.innerWidth || $el.window.width(),
            winH        : window.innerHeight || $el.window.height(),
            docW        : $el.document.outerWidth(),
            docH        : $el.document.outerHeight(),
            linkName    : '',
            dataName    : '',
            switch_flg  : '',
            controller  : '',
            photoNumPath : '',
            photoLen : 1,
            photoNum : '',
            flkty   :'',
            scene  : ''
        };

    $fn.indexSlider = function() {
        if ($('.main-carousel').length) {
             // $fn.mainimgSize();
            var carousel = document.querySelector('.main-carousel');
            param.flkty = new Flickity(carousel, {
                // fade: true,
                percentPosition: false,
                autoPlay: 3000,
                friction: .4,
                contain: true,
                prevNextButtons: false,
                pauseAutoPlayOnHover: true,
                draggable: false,
                pageDots: true,
                wrapAround: true
            });
        }
    };
    $fn.indexSlider();

    $('.ul-qa--item--question').on('click',function () {
        $(this).next().slideToggle(500,'easeOutQuart');
    });

});